import React, { useEffect, useState } from 'react'

import DropdownStringOptions from 'live/components/forms/ui/dropdown/dropdown-string-options'
import i18n from 'live/services/i18n'

import { FilteredSearchRow } from './styles'

type IProps = {
    placeholder?: string
    keyword?: string
    filterOptions?: string[]
    selectedFilterOption?: number
    className?: string
    inputId?: string
    onSearch: (input: string, option?: number) => void
}

let timeoutId = null

export const FilteredSearch: React.FC<IProps> = ({
    keyword,
    placeholder,
    selectedFilterOption,
    filterOptions,
    className,
    inputId,
    onSearch
}) => {
    // const [inputValue, setInputValue] = useState<string>(keyword)

    const handleSearch = (newValue: string, newOptIndex?: number): void => {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => onSearch(newValue ?? keyword, newOptIndex ?? selectedFilterOption), 350)
    }

    // useEffect(() => {
    //     if (keyword && keyword !== inputValue) {
    //         setInputValue(keyword)
    //     }
    // }, [keyword]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <FilteredSearchRow className={className}>
            <div className="filteredSearch-input">
                <i className="fa fa-search" />
                <input
                    id={inputId}
                    defaultValue={keyword}
                    placeholder={placeholder ?? i18n('Type to search')}
                    onChange={e => handleSearch(e?.target?.value ?? '', null)}
                />
            </div>
            {filterOptions && (
                <div className="filteredSearch-filter">
                    <i className="far fa-filter custom-filter" />
                    {/* <div className="dropdown-max-height"> */}
                    <DropdownStringOptions
                        options={filterOptions}
                        selectedOption={selectedFilterOption ?? 0}
                        onSelect={ni => handleSearch(null, ni)}
                        fullWidth={false}
                        disabled={false}
                        className="risk-diagram-filter-max-height"
                    />
                    {/* </div> */}
                </div>
            )}
        </FilteredSearchRow>
    )
}
